export default __webpack_public_path__ + "static/media/lock.5bf52cb1.svg";